export const FONT_SIZE_KEY = 'fontSize';
export const FONT_FAMILY_KEY = 'fontFamily';
export const FONT_COLOR_KEY = 'fontColor';
export const FONT_WEIGHT_KEY = 'fontWeight';
export const FONT_STYLE_KEY = 'fontStyle';
export const STYLING_KEY_LABEL = 'label';
export const SELECTION_COLOR_KEY = 'selectionColor';
export const STICK_TO_KEY = 'stickTo';
export const TEXT_DECORATION_KEY = 'textDecoration';
export const TEXT_TRANSFORM_KEY = 'textTransform';
export const STYLING_KEY_TEXTFIELD = 'textfield';
export const BORDER_WIDTH_KEY = 'borderWidth';
export const BORDER_STYLE_KEY = 'borderStyle';
export const BORDER_RADIUS_KEY = 'borderRadius';
export const BORDER_COLOR_KEY = 'borderColor';
export const BACKGROUND_COLOR_KEY = 'backgroundColor';
export const BACKGROUND_IMAGE_KEY = 'backgroundImage';
export const BACKGROUND_POSITION_KEY = 'backgroundPosition';
export const MARGIN_KEY = 'marginKey';
